/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type Suggest_suggestSearch$ref: FragmentReference;
declare export opaque type Suggest_suggestSearch$fragmentType: Suggest_suggestSearch$ref;
export type Suggest_suggestSearch = {|
  +search: ?$ReadOnlyArray<?{|
    +productKeyword: ?string,
    +productType: ?string,
  |}>,
  +$refType: Suggest_suggestSearch$ref,
|};
export type Suggest_suggestSearch$data = Suggest_suggestSearch;
export type Suggest_suggestSearch$key = {
  +$data?: Suggest_suggestSearch$data,
  +$fragmentRefs: Suggest_suggestSearch$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "Suggest_suggestSearch",
  "type": "SuggestSearch",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "keyword",
      "type": "String",
      "defaultValue": ""
    },
    {
      "kind": "LocalArgument",
      "name": "langCode",
      "type": "String",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "search",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "keyword",
          "variableName": "keyword"
        },
        {
          "kind": "Variable",
          "name": "langCode",
          "variableName": "langCode"
        }
      ],
      "concreteType": "SuggestProduct",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "productKeyword",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "productType",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'f4e161ddf60245705dd0dc801932d220';
module.exports = node;
